// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1K86L","content":"styles_content__1bnkC","row":"styles_row__2o9V2","footer":"styles_footer__3M6MQ","phraseLength":"styles_phraseLength__NLRPT"};